<template>
	<!-- Exclude rule modal : checkout urls where captures should not show -->
	<b-modal id="modal-main-rule" ref="modal-main-rule" no-enforce-focus no-close-on-backdrop cancel-variant="outline-secondary" ok-title="Save" cancel-title="Close" title="Exclude Rule" size="lg" @show="fetchMainRules()" @hidden="removeRulesObject()" @ok="handleOk">
		<b-overlay :show="isSave" :variant="'transparent'" :opacity="'1'" :blur="'2px'" rounded="sm">
			<validation-observer ref="excludeRuleForm">
			<b-form id="main-rule-form" ref="main-rule-form" @submit.stop.prevent="submitMainRuleForm">

				<!-- Url rows -->
				<b-overlay :show="isFetchingRulesArray" :variant="'transparent'" :opacity="'1'" :blur="'2px'" rounded="sm">
					<b-container fluid="md">

						<!-- Static instruction line -->
						<b-row>
							<b-col>
								<span class="text-body">Please add checkout URLs</span>
							</b-col>
						</b-row>

						<b-row class="mt-1 card-body modal-header" v-for="(urlRule, key) in mainRulesObject" :key="key">

							<!-- Url label -->
							<b-col cols="12" md="auto" class="align-self-center">
								<strong>URL</strong>
							</b-col>

							<!-- Url value (wide textbox) -->
							<b-col cols="12" md :class="$isMobile() == true ? `mb-50` : 'pl-0'">
								<validation-provider #default="{ errors }" :name="`checkoutUrl${key}`" :vid="`checkoutUrl${key}`" rules="required" :custom-messages="{ required: 'This field is required' }">
									<b-form-input :name="`rule[choices][${key}]`" placeholder="/specific_url" v-model="urlRule.rule_conditions_choices" />
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<!-- Delete button : any row can be removed, even the last one -->
							<b-col cols="12" md="auto" :class="$isMobile() == false ? 'pl-0 ipadcond' : ''">
								<b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="btn-icon float-sm-right" @click="deleteRowFunction(key)">
									<feather-icon icon="Trash2Icon" />
								</b-button>
							</b-col>

						</b-row>

						<!-- Add more button -->
						<div class="mt-1">
							<b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="addRowFunction()">
								<feather-icon icon="PlusIcon" class="mr-50" />
								<span class="align-middle">Add more</span>
							</b-button>
						</div>
					</b-container>
				</b-overlay>

			</b-form>
			</validation-observer>
		</b-overlay>
	</b-modal>
</template>

<script>
	import {
		BFormInput, BModal, VBModal, BButton, BForm, BCol, BRow, BContainer, BOverlay
	} from 'bootstrap-vue'
	import Ripple from 'vue-ripple-directive'
	import { ValidationProvider, ValidationObserver } from 'vee-validate'
	import { required } from '@validations'
	import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

	export default {
		components: {
			BFormInput, BModal, VBModal, BButton, BForm, BCol, BRow, BContainer, BOverlay,
			ValidationProvider, ValidationObserver,
		},
		directives: {
			Ripple,
		},
		data() {
			return {
				isFetchingRulesArray: false,
				isSave: false,
				mainRulesObject: [],
			}
		},
		methods: {
			/* Get saved exclude rule urls from database */
			fetchMainRules() {
				this.isFetchingRulesArray = true;
				this.$captureSettingAPI.post('fetch-exclude-capture-rules', {
					'site_id': this.$root.appSiteObject.siteId ?? '',
				}).then((response) => {
					response = response.data;
					if (response.status && response.exclude_rules && response.exclude_rules.length) {
						this.mainRulesObject = _.map(response.exclude_rules, (item) => {
							return {
								elementsID: item.elementsID,
								rule_conditions_segment: item.rule_conditions_segment || 'url',
								rule_conditions_choices: item.rule_conditions_choices || '',
							};
						});
					} else {
						this.mainRulesObject = [];
					}
					if (this.mainRulesObject.length == 0) {
						this.addRowFunction(); /* Start with one empty row */
					}
					this.isFetchingRulesArray = false;
				}).catch(() => {
					this.isFetchingRulesArray = false;
				});
			},

			/* Reset state when modal hides */
			removeRulesObject() {
				this.mainRulesObject = [];
			},

			/* Add a new url row */
			addRowFunction() {
				this.mainRulesObject.push({
					elementsID: '',
					rule_conditions_segment: 'url',
					rule_conditions_choices: '',
				});
			},

			/* Delete a url row */
			deleteRowFunction(key) {
				this.$delete(this.mainRulesObject, key);
			},

			/* Stop modal from closing on save, run our handler */
			handleOk(bvModalEvent) {
				bvModalEvent.preventDefault();
				this.submitMainRuleForm();
			},

			/* Save exclude rules to database (blank field shows required error) */
			submitMainRuleForm() {
				this.$refs.excludeRuleForm.validate().then((success) => {
					if (!success) {
						return; /* Some url field is blank, required error is shown */
					}

					this.isSave = true;
					this.$captureSettingAPI.post('save-exclude-capture-rule', {
						'site_id': this.$root.appSiteObject.siteId ?? '',
						'rules': JSON.stringify(this.mainRulesObject),
					}).then((response) => {
						response = response.data;
						this.isSave = false;
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Notification',
								icon: 'BellIcon',
								variant: response.status ? 'success' : 'danger',
								text: response.message,
							},
						});
						if (response.status) {
							this.$refs['modal-main-rule'].hide();
						}
					}).catch(() => {
						this.isSave = false;
					});
				});
			},
		},
	}
</script>

<style lang="scss">
	@media only screen and (max-width: 991px) and (min-width: 768px) {
		.rulecond {
			min-width: 50%;
			max-width: 50%;
			padding-top: 1rem;
			padding-left: 0;
		}

		.ipadcond {
			padding-top: 1rem;
		}
	}
</style>
